import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "i18n-react";

import { Link } from "react-router-dom";

import { Nav, StorageHandler } from "C4";
import { storageKeys, trainingSplit } from "settings";

import Logo from "../../assets/images/logo/logo_white.png";

const TrainingSideBar = ({ chapters, chaptersProgress, filterChapters }) => {
  const [activeItem, setActiveItem] = useState(1);

  const isLocked = (chapterItemCount) => {
    if (chapterItemCount <= 1) {
      return true;
    }

    return false;
  };

  const lastPage = (chapterNumber) => {
    let page = 0;
    chaptersProgress
      .filter((item) => item.chapter === chapterNumber.toString())
      .map((item) => {
        if (item.total_pages !== 0 && item.last_page === item.total_pages) {
          page = 0;
        } else if (
          item.total_pages !== 0 &&
          item.last_page !== item.total_pages
        ) {
          page = item.last_page;
        }
      });

    return page;
  };

  const expandAccordion = (key, startItem, endItem) => {
    filterChapters(startItem, endItem);
    if (activeItem === key) {
      setActiveItem(1);
    } else {
      setActiveItem(key);
    }
  };

  const isFinished = (chapterNumber) => {
    const chapter = chaptersProgress.filter(
      (item) => item.chapter === chapterNumber.toString()
    );

    if (chapter[0].percentage === 100) {
      return true;
    }

    return false;
  };

  const getLastActiveAccordion = (item, startItem, endItem) => {
    StorageHandler.load(storageKeys.lastVisitedChapter).then((res) => {
      if (res) {
        const accordionItems = chapters.slice(startItem, endItem);
        if (
          accordionItems.filter((chapter) => chapter.chapterID === res).length >
          0
        ) {
          filterChapters(startItem, endItem);
          setActiveItem(item);
          if (activeItem === item) {
            StorageHandler.remove("lastVisitedChapter");
          }
        }
      }
    });
  };

  const AccordionItem = ({ item, title, startItem, endItem }) => {
    getLastActiveAccordion(item, startItem, endItem);

    return (
      <div
        className={`trainingSidebar__navigation--accordion ${
          activeItem === item ? "active" : ""
        }`}
      >
        <button onClick={() => expandAccordion(item, startItem, endItem)}>
          <h4 className="accordion__title">
            {title}
            <FontAwesomeIcon
              icon={[
                "fas",
                activeItem === item ? "chevron-up" : "chevron-down",
              ]}
            />
          </h4>
        </button>
        <div className="accordion__content">
          {chapters &&
            chapters.slice(startItem, endItem).map((chapter, i) => {
              const key = i;
              if (isLocked(chapter.chapterItemCount)) {
                return <p key={key}>{chapter.chapterTitle} - COMING SOON</p>;
              }
              return (
                <Link
                  key={key}
                  to={
                    chapter.chapterID === "2918"
                      ? `/main/ret/chapter/${chapter.chapterID}/0`
                      : `/main/training/chapter/${chapter.chapterID}/${lastPage(
                          chapter.chapterID
                        )}`
                  }
                  disabled={isLocked(chapter.chapterItemCount)}
                >
                  {chapter.chapterTitle}
                </Link>
              );
            })}
        </div>
      </div>
    );
  };

  return (
    <div className="trainingSidebar">
      <div className="trainingSidebar__logo">
        <img src={Logo} alt="TravPRO Mobile" />
      </div>
      <Nav className="trainingSidebar__nav" />
      <Link to="/" className="home">
        <FontAwesomeIcon icon={["fas", "home"]} /> <p>Home</p>
      </Link>
      <div className="trainingSidebar__navigation">
        <AccordionItem
          item={1}
          title={i18n.translate("contentHeaders.maintrainings")}
          startItem={0}
          endItem={trainingSplit.foundation}
        />
        <AccordionItem
          item={2}
          title={i18n.translate("contentHeaders.subtrainings")}
          startItem={trainingSplit.foundation}
          endItem={trainingSplit.product}
        />
        <AccordionItem
          item={3}
          title={i18n.translate("contentHeaders.xpoprosubtrainings")}
          startItem={trainingSplit.product}
          endItem={trainingSplit.xpopro}
        />
        <AccordionItem
          item={4}
          title={i18n.translate("contentHeaders.salessubtrainings")}
          startItem={trainingSplit.xpopro}
          endItem={trainingSplit.sales}
        />
        <AccordionItem
          item={5}
          title={i18n.translate("contentHeaders.generalitsubtrainings")}
          startItem={trainingSplit.sales}
          endItem={trainingSplit.it}
        />
        <AccordionItem
          item={6}
          title={i18n.translate("contentHeaders.frontendsubtrainings")}
          startItem={trainingSplit.it}
          endItem={trainingSplit.frontend}
        />
        <AccordionItem
          item={7}
          title={i18n.translate("contentHeaders.nativesubtrainings")}
          startItem={trainingSplit.frontend}
          endItem={trainingSplit.native}
        />
        <AccordionItem
          item={8}
          title={i18n.translate("contentHeaders.backendsubtrainings")}
          startItem={trainingSplit.native}
          endItem={trainingSplit.backend}
        />
      </div>
    </div>
  );
};

TrainingSideBar.propTypes = {
  chapters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  chaptersProgress: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filterChapters: PropTypes.func.isRequired,
};

export default TrainingSideBar;
